import OppInfo from "./OppInfo";
import "../../Assets/Scss/Opportunities.scss";
import { useQuery } from "@tanstack/react-query";
import { useSessionStorage } from "usehooks-ts";
import { TailSpin } from "react-loader-spinner";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ManageApplications from "./ManageApplications";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import UpdateOportunity from "./UpdateOpportunity";

function ManageOpportunity() {
  const api = process.env.REACT_APP_DATABASE_URI;
  const navigate = useNavigate();
  const pathname = window.location.pathname;
  const oppId = pathname.split("/")[3];
  const [sortedApplications, setSortedApplications] = useState([]);
  const [authcode] = useSessionStorage("authToken", "");
  const [tabIndex, setTabIndex] = useState(0);

  //Fetch the positions for the opportunity
  const { isPending: isPendingPositions, data: positions } = useQuery({
    queryKey: ["opportunity_pos", oppId],
    retry: false,
    queryFn: () =>
      fetch(`${api}/opportunities/${oppId}/positions`, {
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authcode}`,
        },
      }).then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      }),
  });

  //Fetch the opportunity
  const {
    isPending,
    isError,
    data: opportunity,
  } = useQuery({
    queryKey: ["opportunity", oppId],
    retry: false,
    queryFn: () =>
      fetch(`${api}/opportunities/` + oppId, {
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authcode}`,
        },
      }).then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      }),
  });

  //Applications for this opportunity
  const {
    isPending: isPendingPos,
    isSuccess,
    isError: isErrorPos,
    data: applications,
  } = useQuery({
    queryKey: ["applications", oppId],
    retry: false,
    queryFn: () =>
      fetch(`${api}/applications/opportunity/` + oppId, {
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authcode}`,
        },
      }).then((res) => res.json()),
  });



  useEffect(() => {
    if (isSuccess && applications) {
      if (applications.detail === "No applications found") {
        setSortedApplications([]);
      } else {
        setSortedApplications(
          applications.sort(
            (a, b) => new Date(a.creation_date) - new Date(b.creation_date)
          )
        );
      }
    }
  }, [isSuccess, applications, positions]);

  if (isPendingPos || isPending) {
    return (
      <TailSpin
        visible={true}
        height="150"
        width="150"
        color="#037EF2"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperClass="spinner"
      />
    );
  }

  if (isError || isErrorPos) {
    navigate(
      "/redirect?code=refresh&return_url=/opportunities/manage/" + oppId
    );
    return <h3>Error fetching</h3>;
  }

  return (
    <div className="manageOppGlobal">
      <OppInfo data={opportunity} appCount={applications.length} />
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
          <Tab>Manage Applications</Tab>
          <Tab>Modify Opportunity</Tab>
        </TabList>
        <TabPanel>
          <ManageApplications
            applications={applications}
            sortedApplications={sortedApplications}
          />
        </TabPanel>
        <TabPanel>
          <UpdateOportunity
            opportunity={opportunity}
            positions={positions}
          />
        </TabPanel>
      </Tabs>
    </div>
  );
}

export default ManageOpportunity;
